export const BRAND = {
  name: "SK Fragrances",
  tagline: "The Art of Fragrance, Perfected Over Generations.",
  since: "1980",
  city: "Bangalore",
  region: "Karnataka, India",
  founder: "Mr. Khan",
  phone: "+91 98452 28243",
  whatsapp: "919845228243",
  email: "info@skfragrances.com",
};

export const IMAGES = {
  logo: "images/SK-logo-nobg.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/57f1a564c3a87d7a585be55131f7cc636536d04703b83800159a79a2a0d1af62.jpeg",
  story: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/b3bc417986828f37ff61f8755ae14139d8a3f623084c00194b8b33743fa6e020.jpeg",
  brandStatement: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/ceb6c22d3b868b77758667fc441bfbab56301a399dac2cc42c533e0a35bfdc15.jpeg",
  economy: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/9e83f556cc93b92b7660ff8eea35c791fb6f081a04f08d3d1f00324677af9d28.jpeg",
  premium: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/6dfed1404feb6165a8222186b87946c4547fa6a39d65302374c60f4f7843ede2.jpeg",
  assorted: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/d9610980d12020a6a47e49fbca9f0903de6200a49764bc988bd3434794fed5dc.jpeg",
  craft: "https://images.pexels.com/photos/18947370/pexels-photo-18947370.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(message)}`;
